// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__10sXK","title":"Header_title__3c_97","side":"Header_side__ixmVm"};